import { useQueryParams } from '../../../hooks/useQueryParams'

interface SupplierListFilters {
  searchQuery?: string
}

type UseSupplierListFiltersResponse = [SupplierListFilters, (filters: Partial<SupplierListFilters>) => void]

const defaultQuery: SupplierListFilters = { searchQuery: undefined }

export const useSupplierListFilters = (): UseSupplierListFiltersResponse =>
  useQueryParams<SupplierListFilters>({ defaultQuery })
